import { createFileRoute } from '@tanstack/react-router'
import { MyMissions } from '@/features/my-missions'

export const Route = createFileRoute('/_authenticated/my-missions')({
  component: MyMissions,
})
